import { useMutation } from '@tanstack/react-query';
import { axios } from '../../config/axios';

interface OnboardStripeCompanyStripeArgs {
  accountId: string;
  url: string;
}

export const useOnboardCompanyStripe = () => {
  return useMutation(
    async ({ accountId, url }: OnboardStripeCompanyStripeArgs): Promise<any> =>
      axios.post('companies/create-company-stripe-link', { accountId, url }),
    {
      onSuccess: async (data) => {
        window.location.replace(data.url);
      },
    },
  );
};
